import { render, staticRenderFns } from "./PrimaryInfo.vue?vue&type=template&id=5a46bdd3"
import script from "./PrimaryInfo.vue?vue&type=script&lang=js"
export * from "./PrimaryInfo.vue?vue&type=script&lang=js"
import style0 from "./PrimaryInfo.vue?vue&type=style&index=0&id=5a46bdd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports